import React, { useEffect, useState } from "react"
import { SlidersHorizontal, ChevronDown } from "lucide-react"
import styles from "./Feed.module.scss"
import type { FeedFilterOption } from "../../../types/feed.ts"
import { exploreFilterLabel } from "../../../utils/feedExploreFilterPayload.ts"

export type FeedExploreFiltersProps = {
  selectedOption: FeedFilterOption
  onSelect: (option: FeedFilterOption) => void
  compact?: boolean
}

const OPTIONS: FeedFilterOption[] = [
  "recientes",
  "recomendados",
  "productos",
  "servicios",
  "posteos",
  "propios",
]

const FeedExploreFilters: React.FC<FeedExploreFiltersProps> = ({
  selectedOption,
  onSelect,
  compact = false,
}) => {
  const [showDropdown, setShowDropdown] = useState(false)

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (showDropdown && !(event.target as Element).closest(`.${styles.dropdown}`)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [showDropdown])

  return (
    <div
      className={`${styles.exploreFilters} ${compact ? styles.exploreFilters_compact : ""}`}
    >
      <div className={styles.dropdown}>
        <span className={styles.header_line} />
        <SlidersHorizontal
          size={14}
          style={{ color: "#000", marginRight: "1rem", minWidth: "1.4rem" }}
        />
        <button
          type="button"
          className={styles.dropdown_button}
          onClick={() => setShowDropdown(!showDropdown)}
        >
          {exploreFilterLabel(selectedOption)}
          <ChevronDown
            size={16}
            className={`${styles.chevron} ${showDropdown ? styles.chevronRotated : ""}`}
          />
        </button>

        {showDropdown && (
          <div className={styles.dropdown_content}>
            {OPTIONS.map((opt) => (
              <button
                key={opt}
                type="button"
                className={`${styles.dropdown_content_option} ${selectedOption === opt ? styles.active : ""}`}
                onClick={() => {
                  onSelect(opt)
                  setShowDropdown(false)
                }}
              >
                {exploreFilterLabel(opt)}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default FeedExploreFilters
